import React from 'react';
import {observer, inject} from 'mobx-react';
import {autorun} from 'mobx';
import {Button, Drawer} from '@enos/dpl';
import {changeTheme} from 'themes-switch';
import localeText from '@locale';
import store from './store';
import Logo from './Logo';
import Profile from './Profile';
import Helper from './Helper';
import Message from './Message';
import {USER_PERMISSION_TYPE, THEME_KEYS} from '~/utils/constants';
import './index.less';
import './mobile.less';
import {Mobile} from '../Responsive';
import MobileMenuBar from '../MobileMenuBar';
import LocaleSwitcher from './LocaleSwitcher';

const THEMES = process.themes;

@inject((stores, props) => {
  const {sessionStore, organizationStore, portalStore} = stores;
  return {
    ...props,
    sessionStore,
    portalStore,
    organizationStore,
    uiStore: store
  };
})
@observer
class Header extends React.Component {
  static defaultProps = {
    prefixClass: 'component-header',
    fromPortal: false
  };

  constructor(props) {
    super(props);
    const {sessionStore, fromAdmin} = this.props;
    this.themeChanger = autorun(() => {
      const {isMobile, theme} = sessionStore;
      let themeKey;
      if (isMobile || fromAdmin) {
        themeKey = THEME_KEYS.DARK;
      } else {
        themeKey = THEME_KEYS[theme];
      }
      if (typeof THEMES === 'object') {
        changeTheme(themeKey, THEMES[themeKey]);
      }
    });
  }

  render() {
    const {simple = false, fromPortal, fromAdmin, prefixClass, sessionStore, uiStore, portalStore, title} = this.props;
    const isAdmin = [USER_PERMISSION_TYPE.OU_ADMIN, USER_PERMISSION_TYPE.SUB_ADMIN].includes(sessionStore.userPermissionType);
    return (
      <div className={prefixClass}>
        {(!sessionStore.isMobile || fromAdmin) && [
          <div className='left' {...{[['key'][0]]: 'left'}}>
            <i
              className='dpl20_menu menu-visibility'
              onClick={() => {
                if (fromPortal) {
                  portalStore.toggleMenu();
                } else {
                  sessionStore.toggleMenu();
                }
              }
              }
            />
            <Logo fromAdminConsole={fromAdmin} />
          </div>,
          <div className='right' {...{[['key'][0]]: 'right'}}>
            {isAdmin && fromPortal && (
              <div className='sub'>
                <Button className='enter-admin-console' href='/admin' ghost>
                  {localeText('PORTAL.BTN_ADMIN_CONSOLE')}
                </Button>
              </div>
            )}
            {fromPortal ? <Message /> : ''}
            <Helper fromAdminConsole={fromAdmin} fromPortal={fromPortal} />
            {!sessionStore.currentUser || simple ? <LocaleSwitcher sessionStore={sessionStore} /> : ''}
            {!simple && <Profile fromPortal={fromPortal} />}
          </div>
        ]}
        <Mobile>
          <div className='header-drawer' onClick={() => uiStore.toggleMenuBarDrawer(true)}>
            <i className='dpl20_menu' />
          </div>
          <div className='header-title'>{title}</div>
          {fromPortal ? (
            <div className='header-alarm'>
              <Message />
            </div>
          ) : (
            ''
          )}
          <Drawer placement='left' closable={false} onClose={() => uiStore.toggleMenuBarDrawer(false)} visible={uiStore.showMenuBar}>
            <MobileMenuBar onClose={() => uiStore.toggleMenuBarDrawer(false)} />
          </Drawer>
        </Mobile>
      </div>
    );
  }

  componentWillUnmount() {
    this.themeChanger();
  }
}

export default Header;
